import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const StyledContainer = styled.View`
  justify-content: center;
  align-items: center;
`;
const Types = ['default', 'review'];
export default function ReferenceCard(props) {
  const textColor = props.type === 'review' ? Colors.gray400 : Colors.gray500;
  const type = Types.includes(props.type) ? props.type : ReferenceCard.defaultProps.type;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    style: type === 'review' && styles.paddedContainer
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: textColor
  }, type === 'review' ? /*#__PURE__*/React.createElement(React.Fragment, null, "Reference No.", ' ', props.referenceNumber) : /*#__PURE__*/React.createElement(React.Fragment, null, "Your Advance Reference Number:")), type === 'default' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyLarge, {
    weight: "bold",
    color: Colors.advanceBlue400
  }, props.referenceNumber)));
}
ReferenceCard.propTypes = {
  referenceNumber: PropTypes.string,
  type: PropTypes.string
};
ReferenceCard.defaultProps = {
  referenceNumber: '',
  type: 'default'
};
const styles = {
  paddedContainer: {
    borderRadius: 4,
    backgroundColor: Colors.lightGray200,
    padding: 8
  }
};
//# sourceMappingURL=reference.js.map